import qs from 'qs';

export default function queryParser(string){
    return qs.parse(string, { ignoreQueryPrefix: true });
}